import FeeTable from './FeeTable';

export default class FeeTableHistory {
    static init(kindergartenId) {
        const feeTableHistory = new FeeTableHistory();
        feeTableHistory.ageRange = { min: 0, max: 99 };
        feeTableHistory.feeTables = [FeeTable.init()];
        feeTableHistory.name = '';
        feeTableHistory.kindergartenId = kindergartenId;
        feeTableHistory.description = '';
        feeTableHistory.id = null;
        feeTableHistory.fee = false;
        feeTableHistory.deletable = true;
        feeTableHistory.impersonalAccount = '';
        feeTableHistory.receivableType = null;

        return feeTableHistory;
    }

    isNew() {
        return this.id === null;
    }

    static fromData(data) {
        if (!data) {
            return;
        }

        const feeTableHistory = new FeeTableHistory();
        feeTableHistory.id = data.id;
        feeTableHistory.ageRange = data.ageRange;
        feeTableHistory.feeTables = data.feeTables.data.map((feeTable) => FeeTable.fromData(feeTable));
        feeTableHistory.name = data.name;
        feeTableHistory.description = data.description;
        feeTableHistory.fee = data.fee;
        feeTableHistory.start = data.start;
        feeTableHistory.impersonalAccount = data.impersonalAccount;
        feeTableHistory.receivableType = data.receivableType;
        feeTableHistory.deletable = data.deletable;

        Object.seal(feeTableHistory);
        return feeTableHistory;
    }

    toData(feeTable) {
        return {
            id: this.id,
            ageRange: this.ageRange,
            feeTable: feeTable.toData(),
            name: this.name,
            fee: this.fee,
            impersonalAccount: this.impersonalAccount,
            receivableType: this.receivableType,
        };
    }
}
